import React from 'react';
import { Services } from 'services';
import { captureEventV2 } from 'utils/events/captureEvent';
import { Events } from '@clariness/tracking-event-runtime';
import { Routing } from 'global/routing';
import { useHistory } from 'react-router-dom';
import { useUserAgreement } from './useUserAgreement';
import { UserAgreementView } from './UserAgreementView';

interface ExternalOidcRegisterUserAgreementProps {
  token: string;
}

export const ExternalOidcRegisterUserAgreement = ({
  token,
}: ExternalOidcRegisterUserAgreementProps) => {
  const history = useHistory();

  const { acceptRegistration, isLoading } =
    Services.SiteEmployees.useAcceptExternalOidcRegistration({
      onSuccess: (data) => {
        captureEventV2(
          Events.InvestigatorService.InvestigatorInvitationAccepted({
            InvestigatorID: data?.id ?? '',
          })
        );
        history.push(Routing.LOGIN.getPath());
      },
      onError: () => resetAgreement(),
    });

  const {
    hasAgreedToAgreement,
    shouldShowPromptMessage,
    onScrollBottomOfAgreement,
    onCheckboxChange,
    resetAgreement,
  } = useUserAgreement(() => acceptRegistration(token));

  return (
    <UserAgreementView
      isLoading={isLoading}
      hasAgreed={hasAgreedToAgreement}
      shouldShowPrompt={shouldShowPromptMessage}
      onScrollBottom={onScrollBottomOfAgreement}
      onCheckboxChange={onCheckboxChange}
    />
  );
};
